@if (infiniteScroll) {
  <div
    class="h-100"
    infiniteScroll
    [infiniteScrollDisabled]="!infiniteScroll"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollUpDistance]="scrollUpDistance"
    [infiniteScrollThrottle]="10"
    [scrollWindow]="false"
    [fromRoot]="true"
    [infiniteScrollContainer]="infiniteScrollContainer"
    (scrolled)="onScroll($event)">
    <ng-container *ngTemplateOutlet="dropList"></ng-container>
  </div>
} @else {
  <div class="drop-list"
    id={{dropListName}}
    cdkDropList
    [ngClass]="{'minimize': minimize}"
    [ngStyle]="{'min-height.px': minHeight, 'max-height.px': maxHeight}"
    [class.item-dragging]="dragging"
    [cdkDropListConnectedTo]="connectedList"
    [cdkDropListSortingDisabled]="disableSort"
    [cdkDropListEnterPredicate]="canDrop"
    [cdkDropListAutoScrollStep]="autoScrollStep"
    (cdkDropListDropped)="droppedIntoList($event)"
    (cdkDropListEntered)="toggleDropListEnter()"
    (cdkDropListExited)="toggleDropListEnter()">
    @for (item of (items | filterElements: filteredElements | orderBy: orderBy | slice: 0: itemsToShow); track _gS.trackById($index, item); let index = $index) {
      <div
        class="item"
        [class.selected]="isSelected(index, item)" cdkDrag
        [cdkDragDisabled]="disableDrag"
        [cdkDragLockAxis]="disableSortOrientation(item)"
        (cdkDragStarted)="dragStarted($event, index, item)" (cdkDragEnded)="dragEnded()" (cdkDragDropped)="dropped($event)"
        (click)="select($event, index, item)" (mousedown)="onMouseDown(index, item)" (dblclick)="onDoubleClick(item, index)"
        (contextmenu)="onSelectedItem($event, item)"
        [ngClass]="{'hide': minimize}">
        @if (!dragging || !isSelected(index)) {
          <div>
            <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: item, item: item, index: index }">
            </ng-container>
          </div>
        }
      </div>
    }
    @if ((!items.length && !isDropListEnter)) {
      <div class="item empty" [ngClass]="{'hide': minimize}">
        <p>{{emptyMsg}}</p>
      </div>
    }
    @if (filteredElements && !filteredElements?.length && items.length && !isDropListEnter) {
      <div class="item empty" [ngClass]="{'hide': minimize}">
        <p>{{'No matching record found' | translate}}</p>
      </div>
    }
  </div>
}

<ng-template #dropList>
  <div class="drop-list"
    id={{dropListName}}
    cdkDropList
    [ngClass]="{'minimize': minimize}"
    [ngStyle]="{'min-height.px': minHeight, 'max-height.px': maxHeight}"
    [class.item-dragging]="dragging"
    [cdkDropListConnectedTo]="connectedList"
    [cdkDropListSortingDisabled]="disableSort"
    [cdkDropListEnterPredicate]="canDrop"
    [cdkDropListAutoScrollStep]="autoScrollStep"
    (cdkDropListDropped)="droppedIntoList($event)"
    (cdkDropListEntered)="toggleDropListEnter()"
    (cdkDropListExited)="toggleDropListEnter()">
    @for (item of (items | filterElements: filteredElements | orderBy: orderBy | slice: 0: itemsToShow); track _gS.trackById($index, item); let index = $index) {
      <div
        class="item"
        [class.selected]="isSelected(index, item)" cdkDrag
        [cdkDragDisabled]="disableDrag"
        [cdkDragLockAxis]="disableSortOrientation(item)"
        (cdkDragStarted)="dragStarted($event, index, item)" (cdkDragEnded)="dragEnded()" (cdkDragDropped)="dropped($event)"
        (click)="select($event, index, item)" (mousedown)="onMouseDown(index, item)" (dblclick)="onDoubleClick(item, index)"
        (contextmenu)="onSelectedItem($event, item)"
        [ngClass]="{'hide': minimize}">
        @if (!dragging || !isSelected(index)) {
          <div>
            <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: item, item: item, index: index }">
            </ng-container>
          </div>
        }
      </div>
    }
    @if ((!items.length && !isDropListEnter)) {
      <div class="item empty" [ngClass]="{'hide': minimize}">
        <p>{{emptyMsg}}</p>
      </div>
    }
    @if (filteredElements && !filteredElements?.length && items.length && !isDropListEnter) {
      <div class="item empty" [ngClass]="{'hide': minimize}">
        <p>{{'No matching record found' | translate}}</p>
      </div>
    }
  </div>
</ng-template>